(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/intersectionWith', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/intersectionWith'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.intersectionWith, global.convert);
    global.intersectionWith = mod.exports;
  }
})(this, function (exports, _intersectionWith2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.intersectionWith = undefined;

  var _intersectionWith3 = _interopRequireDefault(_intersectionWith2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * This method is like {@link array.intersection} except that it uses <code>comparator</code> to compare elements of the former array to <code>arrays</code>.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...Array} [arrays] The arrays to inspect.
   * @param {Function} [comparator] The comparator invoked per element.
   * @return {Object} Returns the updated object.
   * @example intersectionWith({ nested: { prop: [{ x: 1 }, { x: 2 }] } }, 'nested.prop', [{ x: 2 }, { x: 3 }], (a, b) => a.x === b.x) // => { nested: { prop: [{ x: 2 }] } }
   * @see {@link https://lodash.com/docs#intersectionWith|lodash.intersectionWith} for more information.
   * @since 0.3.0
   */
  var intersectionWith = (0, _convert.convert)(_intersectionWith3.default);
  exports.intersectionWith = intersectionWith;
  exports.default = intersectionWith;
});